/**
 * Auto-adds the configured Ecobag gift when the cart has qualifying items.
 * Controlled by theme settings (window.pbcatEcobagGift).
 */
(function () {
  const config = window.pbcatEcobagGift;
  if (!config || !config.enabled || !config.variantId) return;

  const GIFT_PROPERTY = '_ecobag_gift';
  const SOURCE = 'ecobag-gift';
  const CART_MUTATION = /\/cart\/(add|change|update|clear)/i;

  let syncing = false;
  let queued = false;
  let bypassFetch = false;

  function isGiftLine(item) {
    return Boolean(item.properties && item.properties[GIFT_PROPERTY]);
  }

  function hasQualifyingItems(cart) {
    return cart.items.some((item) => {
      if (isGiftLine(item)) return false;
      if (Number(item.variant_id) === Number(config.variantId)) return false;
      return true;
    });
  }

  function findGiftLine(cart) {
    return cart.items.find(isGiftLine);
  }

  async function fetchCart() {
    const response = await fetch(`${window.routes.cart_url}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Failed to load cart');
    return response.json();
  }

  async function cartRequest(url, body) {
    bypassFetch = true;
    try {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (data.status && data.status >= 400) {
        throw new Error(data.description || data.message || 'Cart request failed');
      }
      return data;
    } finally {
      bypassFetch = false;
    }
  }

  function addGift() {
    return cartRequest(`${window.routes.cart_add_url}.js`, {
      id: Number(config.variantId),
      quantity: 1,
      properties: {
        [GIFT_PROPERTY]: 'true',
        Brinde: 'Ecobag',
      },
    });
  }

  function changeLine(key, quantity) {
    return cartRequest(`${window.routes.cart_change_url}.js`, {
      id: key,
      quantity,
    });
  }

  function notifyCartUpdate(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData });
    }

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { source: SOURCE, cart: cartData },
      })
    );
  }

  async function sync() {
    if (syncing) {
      queued = true;
      return;
    }

    syncing = true;
    let changed = false;
    let cartData = null;

    try {
      const cart = await fetchCart();
      const gift = findGiftLine(cart);
      const qualifies = hasQualifyingItems(cart);

      if (qualifies && !gift) {
        cartData = await addGift();
        changed = true;
      } else if (!qualifies && gift) {
        cartData = await changeLine(gift.key, 0);
        changed = true;
      } else if (qualifies && gift && gift.quantity !== 1) {
        cartData = await changeLine(gift.key, 1);
        changed = true;
      }
    } catch (error) {
      console.warn('[ecobag-gift]', error);
    } finally {
      syncing = false;
      if (changed) {
        notifyCartUpdate(cartData);
      }
      if (queued) {
        queued = false;
        await sync();
      }
    }
  }

  function requestUrl(resource) {
    if (typeof resource === 'string') return resource;
    if (resource && typeof resource.url === 'string') return resource.url;
    return '';
  }

  const previousFetch = window.fetch.bind(window);
  window.fetch = async function (...args) {
    const response = await previousFetch(...args);
    if (bypassFetch || syncing) return response;

    try {
      if (CART_MUTATION.test(requestUrl(args[0]))) {
        await sync();
      }
    } catch (error) {
      console.warn('[ecobag-gift]', error);
    }

    return response;
  };

  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__pbcatCartUrl = url;
    return xhrOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    if (this.__pbcatCartUrl && CART_MUTATION.test(String(this.__pbcatCartUrl))) {
      this.addEventListener(
        'load',
        () => {
          if (!bypassFetch && !syncing) sync();
        },
        { once: true }
      );
    }
    return xhrSend.apply(this, args);
  };

  function onCartUpdate(event) {
    if (event && event.source === SOURCE) return;
    sync();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }

  document.addEventListener('cart:updated', (event) => {
    if (event.detail && event.detail.source === SOURCE) return;
    sync();
  });

  window.pbcatEcobagGift.ensure = sync;

  function wrapCheckoutHelpers() {
    if (typeof window.endShopping === 'function' && !window.endShopping.__pbcatWrapped) {
      const originalEndShopping = window.endShopping;
      window.endShopping = function (event) {
        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        sync().finally(() => originalEndShopping.call(this, null));
        return false;
      };
      window.endShopping.__pbcatWrapped = true;
    }
  }

  wrapCheckoutHelpers();
  setInterval(wrapCheckoutHelpers, 1000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }
})();
